import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";

const KPI_DETAIL_MAP = {
  1: {
    title: "전체 프로젝트 수",
    desc: "프로젝트 전체 규모와 최근 30일 추이를 확인합니다.",
    rows: [
      { label: "집계 범위", value: "전체 프로젝트" },
      { label: "추이 기간", value: "최근 30일" },
      { label: "활용 목적", value: "운영 용량 계획" },
    ],
  },
  2: {
    title: "전체 파일 수",
    desc: "파일 누적 건수와 유입 증가 추이를 확인합니다.",
    rows: [
      { label: "집계 범위", value: "전체 업로드" },
      { label: "추이 기간", value: "최근 30일" },
      { label: "활용 목적", value: "저장 공간·처리량 확인" },
    ],
  },
  3: {
    title: "전체 사용자 수",
    desc: "사용자 규모와 최근 유입 추이를 확인합니다.",
    rows: [
      { label: "집계 범위", value: "전체 사용자" },
      { label: "추이 기간", value: "최근 30일" },
      { label: "활용 목적", value: "접근 권한 운영" },
    ],
  },
  4: {
    title: "오류 발생 건수",
    desc: "최근 오류 발생 현황을 확인합니다.",
    rows: [
      { label: "집계 범위", value: "시스템 오류" },
      { label: "추이 기간", value: "최근 24시간" },
      { label: "활용 목적", value: "장애 대응 우선순위" },
    ],
  },
};

export default function AdminKpiDetailPage() {
  const { kpiId } = useParams();

  const detail = useMemo(() => {
    const id = Number(kpiId);
    return KPI_DETAIL_MAP[id] ?? null;
  }, [kpiId]);

  if (!detail) {
    return (
      <section className="content admin adminDetailPage">
        <div className="detailHeader">
          <h2>운영 지표 상세</h2>
          <Link to="/admin" className="ghostLink">
            대시보드로 돌아가기
          </Link>
        </div>
        <div className="card emptyPanel">해당 운영 지표를 찾을 수 없습니다.</div>
      </section>
    );
  }

  return (
    <section className="content admin adminDetailPage">
      <div className="detailHeader">
        <h2>{detail.title}</h2>
        <Link to="/admin" className="ghostLink">
          대시보드로 돌아가기
        </Link>
      </div>

      <div className="card detailIntro">
        <p>{detail.desc}</p>
      </div>

      <div className="card detailTableWrap">
        <table className="detailTable">
          <thead>
            <tr>
              <th>항목</th>
              <th>내용</th>
            </tr>
          </thead>
          <tbody>
            {detail.rows.map((row) => (
              <tr key={row.label}>
                <td>{row.label}</td>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
